<script lang="ts" setup>
import BusinessOnboardingDonutChart from 'pejer/src/components/Chart/Businesses/BusinessOnboardingDonutChart.vue'
import PejerCreatedGraph from 'pejer/src/components/Chart/General/PejerCreatedGraph.vue'
import PejerGraphProvider from 'pejer/src/components/Chart/PejerGraphProvider.vue'
import SectionCard from 'pejer/src/components/ui/section-card/SectionCard.vue'
import SectionCardHeader from 'pejer/src/components/ui/section-card/SectionCardHeader.vue'
import { usePejerBase } from '../../stores/pejerData'
import DataStateDisplay from '../DataState/DataStateDisplay.vue'
const pejer = usePejerBase()
</script>
<template>
  <div class="grid grid-cols-5 gap-2 mb-2">
    <PejerGraphProvider
      v-slot="{ data, dataState }"
      :url="pejer.urls.businesses.stats"
      groupBy="month"
    >
      <div class="flex flex-col gap-2 h-full col-span-3">
        <SectionCard>
          <SectionCardHeader class="w-full"> Total Businesses </SectionCardHeader>
          <DataStateDisplay :="dataState">
            {{ data?.reduce((acc, item) => acc + item.count, 0) }}
          </DataStateDisplay>
        </SectionCard>
        <SectionCard class="flex flex-col gap-2 col-span-3">
          <SectionCardHeader class="w-full"> Businesses Created </SectionCardHeader>
          <div class="flex-grow h-0 flex-1">
            <PejerCreatedGraph :data="data" />
          </div>
        </SectionCard>
      </div>
      <div class="flex flex-col gap-2 h-full col-span-2">
        <div class="flex flex-col gap-2 h-full">
          <SectionCard class="h-full flex items-center">
            <BusinessOnboardingDonutChart :data="data" />
          </SectionCard>
        </div>
      </div>
    </PejerGraphProvider>
  </div>
</template>
